import React from 'react';

const OffersSection = () => {
    const offers = [
        {
            title: "Air Physio",
            image: "https://breatheagain.io/order-confirmation/assets/air-physio.png",
            link: "https://www.clkmg.com/herbalteatherapy/airphysio"
        },
        {
            title: "Lung Master",
            image: "https://breatheagain.io/order-confirmation/assets/Lung-Master.png",
            link: "https://popularhitech.com/intl_12/?prod=lungmaster&net=1044&sid=thankyou&cid=102ee19e5553e17584d03da05f7552"
        },
        {
            title: "Breathing Training Pro",
            image: "https://breatheagain.io/order-confirmation/assets/breathing-training-pro.png",
            link: "https://breathingtrainerpro.qinuxshop.com"
        }
    ];

    return (
        <div>
            {/* Wave Section */}
            <div className="wave-section relative overflow-hidden h-[150px] bg-[85ade1]">
                <div
                    className="absolute bottom-[-1px] left-[-1px] right-[-1px] top-[-1px] z-10 pointer-events-none"
                    style={{
                        backgroundImage:
                            "url('data:image/svg+xml;charset=utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35.28 2.17\" preserveAspectRatio=\"none\"><path d=\"M35.28 1.16c-3.17-.8-7.3.4-10.04.56-2.76.17-9.25-1.47-12.68-1.3-3.42.16-4.64.84-7.04.86C3.12 1.31 0 .4 0 .4v1.77h35.28z\" fill=\"%2385ADE1\"/></svg>')",
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '100% 52px',
                        backgroundPosition: '50% 100%',
                        transform: 'rotateY(180deg)',
                    }}
                ></div>
            </div>

            {/* Offer Container */}
            <div className='bg-[#85ade1] py-14'>

                <div className="offer-container relative z-20 max-w-6xl mx-auto bg-white border-[6px] border-[#132C4D] pt-20 pb-20 px-6">
                    {/* Heading */}
                    <div className="offer-heading text-center mb-8">
                        <h1 className="moneyback text-[#FF1300] font-bold text-[42px] leading-[48px] mb-2 font-sans">
                            BEFORE YOU GO... <br /> CHECK OUT THESE OTHER GREAT DEALS!
                        </h1>
                    </div>

                    {/* Offer List */}
                    <div className="offer-list flex flex-wrap gap-4 justify-center">
                        {offers.map((offer, index) => (
                            <div key={index} className="offer-card flex flex-col items-center w-[30%] min-w-[280px] text-center space-y-5">
                                <h4 className="text-[32px] font-bold mb-4">{offer.title}</h4>
                                <div className="offer-image">
                                    <img
                                        src={offer.image}
                                        alt={offer.title}
                                        className="w-[240px] h-[240px] object-contain"
                                        draggable="false"
                                    />
                                </div>
                                <div className=" flex items-center justify-center text-center text-xs">
                                    <a href={offer.link}>
                                        <img src="https://breatheagain.io/order-confirmation/assets/claim-now-button.png" />
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

        </div>
    );
};

export default OffersSection;
